import type { PublicApiKey } from '@/apilib';
import type { createClassicSectionResizeAndPushApi } from './classicSectionResizeAndPush';

export const ClassicSectionResizeAndPushApiKey: PublicApiKey<
  typeof createClassicSectionResizeAndPushApi
> = {
  name: 'ClassicSectionResizeAndPushApiKey',
  public: true,
};
